export const PHOTO_FILE_NAME_MIN_LENGTH = 1;
export const PHOTO_FILE_NAME_MAX_LENGTH = 500;
